import "./src/styles/global.css";
import React from "react";
import { AppProvider } from "./src/context/AppProvider";

export const wrapRootElement = ({ element }) => {
  return <AppProvider>{element}</AppProvider>;
};
